import {
  TextField,
  InputAdornment,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import useLogin, { EMAIL_KEY, UID_KEY, USER } from '../../hooks/useLogin';
import { ROUTES } from '../../utils/constant';
import {
  loginSx,
  textSx,
  registSx,
  userDialogSx,
} from './styles';
import Copyright from '../../components/Copyright';
import jwt_decode from 'jwt-decode';
import ChatGPTImage from '../../assets/GPT_Logo.png';
import { Building } from '../../assets/Building';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { addLogin, addUser, getLogin, getUser } from '../../api/apis';
import { Controller, useForm } from 'react-hook-form';

function validInput (email: string, password: string) {
  const EMAIL_REG =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i;
  if (email.length < 3 || password.length < 3) {
    return false;
  }
  return EMAIL_REG.test(email);
}

interface registCheck {
  email: boolean;
  password: boolean;
  confirm: boolean;
  company: boolean;
  location: boolean;
  registSuccuss: boolean;
}

interface LoginFormData {
  email: string;
  password: string;
  language: string;
  loginTo: 'e-learning' | 'chatGPT';
}

export default function LoginPage () {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const { isLogin } = useLogin();
  const { control, watch, handleSubmit } = useForm<LoginFormData>({
    defaultValues: {
      email: '',
      password: '',
      language: sessionStorage.getItem('lang') || 'en',
      loginTo: 'chatGPT',
    },
  });

  const [isFormValid, setIsFormValid] = useState(false);
  const watchFields = watch(['email', 'password']);
  const watchLanguage = watch('language');
  useEffect(() => {
    const [email, password] = watchFields;
    setIsFormValid(validInput(email, password));
  }, [watchFields]);

  useEffect(() => {
    console.log(watchLanguage);
    i18n.changeLanguage(watchLanguage);
  }, [watchLanguage]);

  const [isPasswordVisible, togglePasswordVisible] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const [registEmail, setRegistEmail] = useState('');
  const [registPW, setRegistPW] = useState('');
  const [registComfirmPW, setRegistComfirmPW] = useState('');
  const [registCompany, setRegistCompany] = useState('');
  const [registLocation, setRegistLocation] = useState('');
  const [showLogin, setShowLogin] = useState(true);
  const [isValidRegist, setIsValidRegist] = useState(false);
  const [registStatus, setRegistStatus] = useState<registCheck>({
    email: false,
    password: false,
    confirm: false,
    company: false,
    location: false,
    registSuccuss: false,
  });
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  useEffect(() => {
    if (isLogin) {
      history.push(ROUTES.courses);
    }
  }, [isLogin, history]);

  const onSubmit = async (data: LoginFormData) => {
    const result = await getLogin({
      email: data.email,
      password: data.password,
    });

    if (result.data.status === '1') {
      const login = result.data.login;
      const decode = jwt_decode(login.access_token);
      if (decode.exp) { sessionStorage.setItem('expired', (decode.exp * 1000).toString()); }
      localStorage.setItem('ACCESS_TOKEN', login.access_token);
      localStorage.setItem('REFRESH_TOKEN', login.refresh_token);

      if (data.loginTo === 'chatGPT') {
        window.location.replace('/chatbot/main');
      } else {
        sessionStorage.setItem(UID_KEY, login.uid);
        sessionStorage.setItem(EMAIL_KEY, login.email);
        sessionStorage.setItem('ACCESS_TOKEN', login.access_token);
        sessionStorage.setItem('REFRESH_TOKEN', login.refresh_token);
        sessionStorage.setItem('IsCheckInactive', '0');
        sessionStorage.setItem('lang', data.language);
        getUser({ email: login.email }).then((res) => {
          if (res.data.status === '1') {
            const user = res.data.user;
            sessionStorage.setItem(USER, JSON.stringify(user));
            history.push(ROUTES.courses);
          }
        });
      }
    } else if (result.data.status === '-5') {
      // Need to Comfirm this status
      setErrorMsg(
        'Your login is inactive, please contact your supervisor if applicable.',
      );
    } else setErrorMsg('Incorrect email or password');
  };

  const onRegist = async () => {
    const loginRes = await addLogin({
      company: 'hpt00',
      email: registEmail,
      password: registPW,
    });

    if (loginRes.data.status === '-2') {
      setErrorMsg('This email has already been registered');
      return;
    }

    if (loginRes.data.status !== '1') {
      setErrorMsg('Something went wrong, please try again later');
      return;
    }

    const userRes = await addUser({
      company_id: 'hpt00',
      email: registEmail,
      name: `User ${registEmail.substring(0, registEmail.lastIndexOf('@'))}`,
      role: 'trainee',
      tel: '',
      department: 'AD',
      location: registLocation,
      jobtype: 'None',
    });

    if (userRes.status !== 200) {
      setOpen(true);
    }

    if (userRes.data.status === '-2') {
      setErrorMsg('This email has already been registered');
      return;
    }

    setRegistStatus((prevState) => {
      return {
        ...prevState,
        registSuccuss: true,
      };
    });

    setOpen(true);
  };

  useEffect(() => {
    setIsValidRegist(validIRegist());
  }, [registEmail, registPW, registComfirmPW, registCompany, registLocation]);
  function succussAndClose () {
    setRegistEmail('');
    setRegistPW('');
    setRegistComfirmPW('');
    setRegistCompany('');
    setRegistLocation('');
    setOpen(false);
    setShowLogin(true);
  }

  function validIRegist () {
    const EMAIL_REG =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i;
    const PASSWORD_REG =
      /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{8,128})/i;
    let returnFlag = true;
    if (!registEmail || !EMAIL_REG.test(registEmail)) {
      setRegistStatus((prevState) => {
        return {
          ...prevState,
          email: true,
        };
      });
      returnFlag = false;
    } else {
      setRegistStatus((prevState) => {
        return {
          ...prevState,
          email: false,
        };
      });
    }
    if (!registPW || !PASSWORD_REG.test(registPW)) {
      setRegistStatus((prevState) => {
        return {
          ...prevState,
          password: true,
        };
      });
      returnFlag = false;
    } else {
      setRegistStatus((prevState) => {
        return {
          ...prevState,
          password: false,
        };
      });
    }
    if (
      !registComfirmPW ||
      !PASSWORD_REG.test(registComfirmPW) ||
      registComfirmPW !== registPW
    ) {
      setRegistStatus((prevState) => {
        return {
          ...prevState,
          confirm: true,
        };
      });
      returnFlag = false;
    } else {
      setRegistStatus((prevState) => {
        return {
          ...prevState,
          confirm: false,
        };
      });
    }
    // if (!registCompany || registCompany.length < 3) {
    //   setRegistStatus(prevState => {
    //     return {
    //       ...prevState,
    //       company: true,
    //     };
    //   });
    //   returnFlag = false;
    // } else {
    //   setRegistStatus(prevState => {
    //     return {
    //       ...prevState,
    //       company: false,
    //     };
    //   });
    // }
    if (registLocation.length > 20) {
      setRegistStatus((prevState) => {
        return {
          ...prevState,
          location: true,
        };
      });
      returnFlag = false;
    } else {
      setRegistStatus((prevState) => {
        return {
          ...prevState,
          location: false,
        };
      });
    }
    return returnFlag;
  }
  const handleClose = () => {
    setOpen(false);
    // setShowLogin(true)
  };
  return (
    <main
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#343541',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {
      showLogin
        ? (
          <Box sx={loginSx}>
            <img className="logo" src={ChatGPTImage} alt="logo" />
            <div className="title">{t('ChatGPT Secure Platform')}</div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Controller
                name="email"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    sx={textSx}
                    label={t('Email')}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MailOutlineIcon sx={{ color: 'white' }} />
                        </InputAdornment>
                      ),
                    }}
                    variant="standard"
                    type="email"
                  />
                )}
              />
              <Controller
                name="password"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    sx={textSx}
                    label={t('Password')}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <i className="bi bi-key" style={{ color: 'white' }} />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          onClick={() => {
                            togglePasswordVisible(!isPasswordVisible);
                          }}
                        >
                          {isPasswordVisible
                            ? (
                            <i className="bi bi-eye-slash" style={{ color: 'white' }} />
                              )
                            : (
                            <i className="bi bi-eye" style={{ color: 'white' }} />
                              )}
                        </InputAdornment>
                      ),
                    }}
                    variant="standard"
                    type={isPasswordVisible ? 'text' : 'password'}
                  />
                )}
              />
              <div style={{ textAlign: 'center' }}>
                <Button variant="outlined" disabled={!isFormValid} type="submit">
                  {t('Login')}
                </Button>
              </div>
              {errorMsg && <div className="error-msg">{errorMsg}</div>}
            </form>

            <div>
              <span className="askRegister">
                {t('Not registered yet?')}&nbsp;
                <a
                  className="regist"
                  onClick={() => {
                    setShowLogin(false);
                    setErrorMsg('');
                  }}
                >
                  &nbsp;
                  {t('Register now')}
                </a>
              </span>
            </div>
          </Box>
          )
        : (
        <Box sx={loginSx}>
          <img className="logo" src={ChatGPTImage} alt="logo" />
          <div className="title">{t('Register account')}</div>
          <TextField
            sx={registSx}
            label={t('Email') + ' *'}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <MailOutlineIcon sx={{ color: 'white' }} />
                </InputAdornment>
              ),
            }}
            value={registEmail}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setRegistEmail(event.target.value);
            }}
            variant="standard"
            type="text"
            error={registStatus.email}
          />
          <div className="validInfo">{t('Valid email address')}</div>
          <TextField
            sx={registSx}
            id="registPassword"
            label={t('Password') + ' *'}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <i className="bi bi-key" style={{ color: 'white' }} />
                </InputAdornment>
              ),
            }}
            value={registPW}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setRegistPW(event.target.value);
            }}
            variant="standard"
            type="password"
            error={registStatus.password}
          />
          <div className="validInfo">
            {t('Use 8 or more characters with a mix of letters and numbers')}
          </div>
          <TextField
            sx={registSx}
            id="ComfirmPW"
            label={t('Confirm password') + ' *'}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <i className="bi bi-key" style={{ color: 'white' }} />
                </InputAdornment>
              ),
            }}
            value={registComfirmPW}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setRegistComfirmPW(event.target.value);
            }}
            variant="standard"
            type="password"
            error={registStatus.confirm}
          />
          <div className="validInfo">{t('Enter password again')}</div>
          <TextField
            sx={registSx}
            label={t('Company name') + ' *'}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Building />
                </InputAdornment>
              ),
            }}
            value={
              'Hoplite Technology'
              // registCompany
            }
            disabled
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setRegistCompany(event.target.value.toUpperCase());
            }}
            variant="standard"
            type="text"
            error={registStatus.company}
          />
          <div className="validInfo"> </div>
          <TextField
            sx={registSx}
            label={t('Location')}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LocationOnOutlinedIcon sx={{ color: 'white' }} />
                </InputAdornment>
              ),
            }}
            value={registLocation}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setRegistLocation(event.target.value);
            }}
            variant="standard"
            type="text"
            error={registStatus.location}
          />
          <div style={{ textAlign: 'center', marginTop: '25px' }}>
            <Button
              variant="outlined"
              disabled={!isValidRegist}
              onClick={onRegist}
            >
              {t('Register')}
            </Button>
          </div>
          {errorMsg && <div className="error-msg">{errorMsg}</div>}
          <div>
            <span className="askRegister">
              {t('Already have an account?')}&nbsp;
              <a
                className="regist"
                onClick={() => {
                  setShowLogin(true);
                  setErrorMsg('');
                }}
              >
                &nbsp;
                {t('Login')}
              </a>
            </span>
          </div>
        </Box>
          )}
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        sx={userDialogSx}
        maxWidth="md"
      >
        <i className="bi bi-x" onClick={handleClose} />
        {registStatus.registSuccuss
          ? (
          <>
            <DialogContent>
              <div
                className="confirm-row"
                style={{
                  color: '#009869',
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  paddingTop: '40px',
                }}
              >
                Successful create account
              </div>
              <span className="ok-login">You can login now</span>
            </DialogContent>
            <DialogActions>
              <Button variant="contained" onClick={succussAndClose}>
                Close
              </Button>
            </DialogActions>
          </>
            )
          : (
          <>
            <DialogContent>
              <div
                className="confirm-row"
                style={{
                  color: '#009869',
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  paddingTop: '40px',
                }}
              >
                Cannot create account
              </div>
              <span className="ok-login">
                Please contact{' '}
                <a className="regist" href="mailto:info@hoplite-tech.com">
                  info@hoplite-tech.com
                </a>
              </span>
            </DialogContent>
            <DialogActions>
              <Button variant="contained" onClick={handleClose}>
                Close
              </Button>
            </DialogActions>
          </>
            )}
      </Dialog>
      <Copyright />
    </main>
  );
}
